/**
 * UNIWERSALNA funkcja do konwersji ścieżek zdjęć
 * Używana wszędzie gdzie wyświetlamy zdjęcia z backendu
 * 
 * Obsługuje formaty:
 * - Pełne URL-e HTTP/HTTPS (naprawia stare URL-e z petlitter.emergent.host)
 * - Ścieżki /uploads/... (dodaje pełny backend URL)
 * - Ścieżki /api/uploads/... (dodaje backend URL)
 * - Nazwy plików z wariantami (dodaje pełną ścieżkę)
 * - Puste/null (zwraca null)
 */

// Always use current origin for backend URLs
const getBackendUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
};

const BACKEND_URL = getBackendUrl();

// Stary host który trzeba zamienić
const OLD_HOST = 'petlitter.emergent.host';

export const getImageUrl = (path) => {
  // Brak ścieżki - zwróć null
  if (!path) return null;
  
  // Pełny URL - sprawdź czy trzeba naprawić stary host
  if (path.startsWith('http://') || path.startsWith('https://')) {
    // Napraw stare URL-e z petlitter.emergent.host
    if (path.includes(OLD_HOST)) {
      const fixedPath = path.replace(`https://${OLD_HOST}`, BACKEND_URL)
                            .replace(`http://${OLD_HOST}`, BACKEND_URL);
      return fixedPath;
    }
    return path;
  }
  
  // Ścieżka zaczyna się od /uploads/ - dodaj pełny URL z /api
  if (path.startsWith('/uploads/')) {
    return `${BACKEND_URL}/api${path}`;
  }
  
  // Ścieżka już ma /api/uploads/ - dodaj backend URL
  if (path.startsWith('/api/uploads/')) {
    return `${BACKEND_URL}${path}`;
  }
  
  // Nazwa pliku z wariantem (np. abc123_medium.webp) - dodaj pełną ścieżkę
  if (path.includes('_medium.webp') || 
      path.includes('_large.webp') || 
      path.includes('_thumb.webp') || 
      path.includes('_small.webp') ||
      path.includes('_original.webp')) {
    return `${BACKEND_URL}/api/uploads/${path}`;
  }
  
  // Inne ścieżki - spróbuj dodać /api/uploads/ jeśli wygląda jak nazwa pliku
  if (path.includes('.') && !path.includes('/')) {
    // Wygląda jak nazwa pliku bez ścieżki
    return `${BACKEND_URL}/api/uploads/${path}`;
  }
  
  // Domyślnie - zwróć jak jest (z backend URL jeśli relatywna)
  if (path.startsWith('/')) {
    return `${BACKEND_URL}${path}`;
  }
  
  return path;
};

// Placeholder dla brakujących zdjęć (legacy fallback — szary)
export const PLACEHOLDER_IMAGE = "https://static.prod-images.emergentagent.com/jobs/dc177248-a192-4743-b1c2-b2d820060990/images/cabf03240c3b22cd85108763e7cb2e89d9c021f4d0398511057e7ac8b4943571.png";

// Type-specific placeholdery (v2 P0) — ładne zaślepki dla pustych profili
export const PLACEHOLDER_BY_TYPE = {
  miot: '/placeholders/szczenieta.png',           // Szczenięta wkrótce (zielony)
  szczenieta: '/placeholders/szczenieta.png',
  mioty: '/placeholders/szczenieta.png',
  reproduktor: '/placeholders/reproduktor.png',   // Zdjęcia psa wkrótce (fioletowy)
  reproduktory: '/placeholders/reproduktor.png',
  hodowla: '/placeholders/hodowla.png',           // Hodowla wkrótce doda zdjęcia (gold)
  hodowle: '/placeholders/hodowla.png',
};

// Wybór zaślepki per typ. Fallback: hodowla (najbardziej neutralna).
export const getPlaceholderByType = (type) => {
  if (!type) return PLACEHOLDER_BY_TYPE.hodowla;
  return PLACEHOLDER_BY_TYPE[type] || PLACEHOLDER_BY_TYPE.hodowla;
};

// Helper do uzyskania zdjęcia z fallbackiem
export const getImageWithFallback = (path, type = null) => {
  return getImageUrl(path) || (type ? getPlaceholderByType(type) : PLACEHOLDER_IMAGE);
};

export default getImageUrl;
